<template>
    <a :href="linkToDoc">{{ this.title }}</a>
</template>

<script>

export default {
    components: {

    },
    data() {
        return {
            API_PATH: null
        }
    },
    props: {
        path: {
            type: String,
        },
        hash: {
            type: String,
        },
        title: {
            type: String,
        },

    },
    computed: {
        linkToDoc() {
            return `${this.API_PATH}/${this.path}${this.hash}`
        }
    },
    methods: {
    },
    created() {
        switch (process.env.VUE_APP_MODE_BUILD) {
            case 'serve-hmr':
                this.API_PATH = 'http://api.sirius.development'
                break
            case 'development':
                this.API_PATH = 'http://api.yandexrent.development'
                break
            case 'production':
                this.API_PATH = 'https://api.crmrent.com'
                break
            case 'testing':
                this.API_PATH = 'https://api.crmtest.ru'
                break
        }
    }
};
</script>